import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import BottomTabBar from "@/components/BottomTabBar";
import TopNavBar from "@/components/TopNavBar";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Car, MessageSquare, Package, Calendar } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Layout({ children }) {
    const [fabOpen, setFabOpen] = useState(false);
    const navigate = useNavigate();
    const { user } = useAuth();

    return (
        <div className="min-h-screen bg-onyx-900 text-white pb-24 md:pb-6">
            <TopNavBar onFabClick={() => setFabOpen(true)} />
            {children ?? <Outlet context={{ openFab: () => setFabOpen(true) }} />}
            <BottomTabBar onFabClick={() => setFabOpen(true)} />

            <Dialog open={fabOpen} onOpenChange={setFabOpen}>
                <DialogContent
                    className="surface border-onyx-600 rounded-md max-w-md"
                    data-testid="fab-choice-dialog"
                >
                    <DialogHeader>
                        <DialogTitle className="headline text-2xl">What are we doing?</DialogTitle>
                    </DialogHeader>
                    <div className="grid grid-cols-1 gap-3 mt-2">
                        <button
                            data-testid="fab-create-listing"
                            onClick={() => {
                                setFabOpen(false);
                                if (!user) return navigate("/login");
                                navigate("/listings/new");
                            }}
                            className="surface-elevated rounded-md p-4 flex items-center gap-4 hover:border-hellcat transition-colors text-left"
                            style={{ transition: "border-color 0.15s" }}
                        >
                            <div
                                className="w-11 h-11 rounded-md flex items-center justify-center"
                                style={{ background: "#E10600" }}
                            >
                                <Car className="w-6 h-6" />
                            </div>
                            <div>
                                <div className="headline text-lg">Create Listing</div>
                                <div className="text-sm text-onyx-500">
                                    Sell an SRT / R/T / Hellcat / TRX
                                </div>
                            </div>
                        </button>
                        <button
                            data-testid="fab-create-post"
                            onClick={() => {
                                setFabOpen(false);
                                if (!user) return navigate("/login");
                                navigate("/community/new");
                            }}
                            className="surface-elevated rounded-md p-4 flex items-center gap-4 hover:border-hellcat transition-colors text-left"
                        >
                            <div
                                className="w-11 h-11 rounded-md flex items-center justify-center"
                                style={{ background: "#1A1A1A", border: "1px solid #E10600" }}
                            >
                                <MessageSquare className="w-6 h-6 text-hellcat" />
                            </div>
                            <div>
                                <div className="headline text-lg">Create Community Post</div>
                                <div className="text-sm text-onyx-500">
                                    Share a build, ask for parts, or start a thread
                                </div>
                            </div>
                        </button>
                        <button
                            data-testid="fab-create-part"
                            onClick={() => {
                                setFabOpen(false);
                                if (!user) return navigate("/login");
                                navigate("/parts/new");
                            }}
                            className="surface-elevated rounded-md p-4 flex items-center gap-4 hover:border-hellcat transition-colors text-left"
                        >
                            <div
                                className="w-11 h-11 rounded-md flex items-center justify-center"
                                style={{ background: "#1A1A1A", border: "1px solid #E10600" }}
                            >
                                <Package className="w-6 h-6 text-hellcat" />
                            </div>
                            <div>
                                <div className="headline text-lg">List a Part</div>
                                <div className="text-sm text-onyx-500">
                                    Wheels, headers, ECU, exhaust, whatever
                                </div>
                            </div>
                        </button>
                        <button
                            data-testid="fab-create-event"
                            onClick={() => {
                                setFabOpen(false);
                                if (!user) return navigate("/login");
                                navigate("/events");
                            }}
                            className="surface-elevated rounded-md p-4 flex items-center gap-4 hover:border-hellcat transition-colors text-left"
                        >
                            <div
                                className="w-11 h-11 rounded-md flex items-center justify-center"
                                style={{ background: "#1A1A1A", border: "1px solid #E10600" }}
                            >
                                <Calendar className="w-6 h-6 text-hellcat" />
                            </div>
                            <div>
                                <div className="headline text-lg">Post an Event</div>
                                <div className="text-sm text-onyx-500">
                                    Cruise-ins, drag nights, meets
                                </div>
                            </div>
                        </button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
